import { Col, Row, Tabs, TabsProps } from "antd";
import React from "react";
import TaxRates from "./TaxRates";
import { CTConfigurationPageType } from "../../Services/CTConfigurationService";
import CapitalAllowance from "./CapitalAllowance";
import RnDRates from "./RnDRates";
import AnnualInvestmentAllowance from "./AnnualInvestmentAllowance";
import AssetCategories from "./AssetCategories";
import CompanyNames from "./CompanyNames";
import { PageLayout, PageHeader } from "../../Common/Layout";

const CTConfiguration = () => {
  // const [loading, setLoading] = React.useState(false);
  const [pageType, setPageType] = React.useState({
    type: CTConfigurationPageType.TaxRates,
  });

  const onChange = (key: any) => {
    var num = parseInt(key, 10);
    setPageType({ type: num });
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Tax rates",
    },
    {
      key: "2",
      label: "Capital allowance",
    },
    {
      key: "3",
      label: "R & D rates",
    },
    {
      key: "4",
      label: "Annual investment allowance",
    },
    {
      key: "5",
      label: "Asset categories",
    },
    {
      key: "6",
      label: "Company Names",
    },
  ];
  return (
    <PageLayout>
      <PageHeader
        title="CT Configuration"
        subtitle="Configure tax rates, capital allowances, R&D rates, investment allowances, asset categories, and company names"
      />
      <Row
        className="roundedCornerSmall px-3 py-1"
        style={{ backgroundColor: "white", minHeight: "100%" }}
      >
        <Col span={24}>
          <Row style={{ marginTop: 8 }}>
            <Col span={24}>
              <Tabs
                defaultActiveKey="1"
                size="small"
                items={items}
                onChange={onChange}
              />
            </Col>
          </Row>
          {pageType.type === CTConfigurationPageType.TaxRates && <TaxRates />}
          {pageType.type === CTConfigurationPageType.CapitalAllowance && (
            <CapitalAllowance />
          )}
          {pageType.type === CTConfigurationPageType.RnDRates && <RnDRates />}
          {pageType.type ===
            CTConfigurationPageType.AnnualInvestmentAllowance && (
              <AnnualInvestmentAllowance />
            )}
          {pageType.type === CTConfigurationPageType.AssetCategories && (
            <AssetCategories />
          )}
          {pageType.type === CTConfigurationPageType.CompanyNames && (
            <CompanyNames />
          )}
        </Col>
      </Row>
    </PageLayout>
  );
};

export default CTConfiguration;

